module.exports = __webpack_public_path__ + "static/img/revolution_logo_default.8248832.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/revolution_logo_default.png
// module id = Wzgh
// module chunks = 1